
import { RSSFeedTester } from '@/components/admin/RSSFeedTester';
import { Helmet } from 'react-helmet';

const RSSFeedTest = () => {
  return (
    <>
      <Helmet>
        <title>RSS Feed Tester | Travel CMS</title>
      </Helmet>
      <div className="space-y-6">
        <div className="flex flex-col gap-2">
          <h1 className="text-3xl font-bold tracking-tight">RSS Feed Tester</h1>
          <p className="text-muted-foreground">
            Test and debug RSS feeds to ensure proper content extraction
          </p>
        </div>
        <RSSFeedTester />
      </div>
    </>
  );
};

export default RSSFeedTest;
